var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27498 12.775C9.56748 12.4825 9.56748 12.01 9.27498 11.7175L7.24998 9.6925L6.19248 10.75L8.21748 12.775C8.50998 13.0675 8.98998 13.0675 9.27498 12.775ZM2.53248 4H4.24998V8.1925L0.717483 11.7175C0.424983 12.01 0.424983 12.4825 0.717483 12.775C1.00998 13.0675 1.48248 13.0675 1.77498 12.775L5.30748 9.25C5.59248 8.965 5.74998 8.59 5.74998 8.1925V4H7.46748C7.80498 4 7.96998 3.595 7.72998 3.3625L5.26248 0.895001C5.11248 0.745001 4.87998 0.745001 4.72998 0.895001L2.26248 3.3625C2.02998 3.595 2.19498 4 2.53248 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIconSmall);
export default __webpack_public_path__ + "static/media/merge_icon_small.9205ee63.svg";
export { ForwardRef as ReactComponent };